import { FC } from 'react';

import { STORAGE_KEYS } from '@/constants';
import { useDismissibleBanner } from '@/hooks';

import styles from './styles.module.scss';

import CloseIcon from '@/assets/icons/close.svg?react';
import LightTipIcon from '@/assets/icons/light-tip.svg?react';

const ANALYST_BANNER_TEXT = 'Explore my AIRES data';

export const AnalystBanner: FC = () => {
  const { isVisible, dismiss } = useDismissibleBanner(STORAGE_KEYS.ANALYST_BANNER_HIDDEN);

  if (!isVisible) {
    return null;
  }

  return (
    <div className={styles.alert} role="region" aria-label="CU Data Analyst banner">
      <div className={styles.alertItem}>
        <LightTipIcon className={styles.alertIcon} />
        <p className={styles.alertItemText}>{ANALYST_BANNER_TEXT}</p>
      </div>

      <div className={styles.alertItem}>
        <a
          className={styles.alertButton}
          href={`${import.meta.env.VITE_CUDA_URL}/agent`}
          aria-label="Open the CU Data Analyst"
        >
          Open
        </a>

        <div className={styles.alertClose}>
          <button className={styles.alertCloseBtn} type="button" aria-label="Dismiss banner" onClick={dismiss}>
            <CloseIcon />
          </button>
        </div>
      </div>
    </div>
  );
};
